//import { Roboto_300Light, Roboto_400Regular, Roboto_500Medium, Roboto_700Bold, useFonts } from '@expo-google-fonts/roboto';
import { Poppins_300Light, Poppins_400Regular, Poppins_500Medium, Poppins_700Bold, useFonts } from '@expo-google-fonts/poppins';
import AppLoading from 'expo-app-loading';
import { LinearGradient } from 'expo-linear-gradient';
import React from "react";
import { ScrollView, View } from 'react-native';
import { RootSiblingParent } from "react-native-root-siblings";
import Routes from "./src/routes";
import { useEffect } from 'react';
import {LanguageProvider} from "./src/context/LanguageContext";

export default function App() {
  let [fontsLoaded] = useFonts({
    Poppins_300Light, Poppins_400Regular, Poppins_500Medium, Poppins_700Bold
  });

  if (!fontsLoaded) {
    return <AppLoading />;
  } else {
    return (
      // <Layout>
        <RootSiblingParent>
          <LanguageProvider>
            <Routes />
          </LanguageProvider>
        </RootSiblingParent>
      // </Layout>
    );
  }
}

const Layout = ({ children }) => (
  <LinearGradient
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    colors={['rgba(22, 87, 110, 1)', 'rgba(25, 153, 145, 1)']}
  >
    <ScrollView
      style={{
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 0,
        },
        shadowOpacity: 0.72,
        shadowRadius: 16,

        elevation: 25,
      }}
    >
      <View style={{
        maxWidth: '1024px',
        minHeight: '100vh',
        maxHeight: '100vh',
        width: '100vw',
        margin: '0 auto',
        marginHorizontal: 'auto'
      }}>
        { children }
      </View>
    </ScrollView>
  </LinearGradient>
)
